var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChangePassword',{staticStyle:{"margin-top":"-20px"},attrs:{"page":"lostpassword"}})}
var staticRenderFns = []

export { render, staticRenderFns }